import React from 'react';
import {useTranslation} from 'react-i18next';
import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '../../utils/constants';
import {PrivacyPolicySettings} from '@guestapp/sdk';
import {getDocumentDownloadByLanguage} from '../../utils/common';
import {useChekinSDK} from '../../context/ChekinSDK';
import {useReservation} from '../../context/reservation';
import Link from '../common/Link';

function PrivacyPolicyLink() {
  const {t, i18n} = useTranslation();
  const {housingId} = useReservation();
  const {getPrivacyPolicy} = useChekinSDK();

  const {data: privacyPolicySettings, isInitialLoading} = useQuery<PrivacyPolicySettings>(
    [QUERY_CACHE_KEYS.privacyPolicySettings, housingId],
    () => getPrivacyPolicy(housingId || ''),
    {
      enabled: !!housingId,
      refetchOnWindowFocus: false,
    },
  );

  const hasCustomPrivacyPolicy = Boolean(
    privacyPolicySettings?.has_custom_privacy_policy,
  );

  const documentDownload = React.useMemo(() => {
    if (privacyPolicySettings) {
      return getDocumentDownloadByLanguage(privacyPolicySettings, i18n.language);
    }

    return '';
  }, [i18n.language, privacyPolicySettings]);

  return hasCustomPrivacyPolicy ? (
    <Link
      download
      href={documentDownload}
      label={t('privacy_policy')}
      disabled={isInitialLoading || !documentDownload}
    />
  ) : (
    <Link href={t('guest_privacy_policy_link')} label={t('privacy_policy')} />
  );
}

export {PrivacyPolicyLink};
